import { render, staticRenderFns } from "./BaseBoard.vue?vue&type=template&id=1b653564"
import script from "./BaseBoard.vue?vue&type=script&lang=ts"
export * from "./BaseBoard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports